import { render, staticRenderFns } from "./OvgResumenMobileBar.vue?vue&type=template&id=62190839&scoped=true"
import script from "./OvgResumenMobileBar.vue?vue&type=script&lang=js"
export * from "./OvgResumenMobileBar.vue?vue&type=script&lang=js"
import style0 from "./OvgResumenMobileBar.vue?vue&type=style&index=0&id=62190839&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62190839",
  null
  
)

export default component.exports